
// import { Link, useHistory } from 'react-router-dom';
// import '../theme/imageCard.css'
import { SiUnity, SiCplusplus, SiMongodb, SiGithub, SiMysql, SiBlender, SiAutodesk, SiAdobephotoshop, SiAdobeaftereffects, SiJavascript, SiTypescript, SiNextdotjs, SiReact, SiExpress, SiNatsdotio, SiReactivex, SiAwslambda, SiAmazonaws } from 'react-icons/si'
// import { TbShape } from 'react-icons/tb'
import { FaNodeJs } from 'react-icons/fa'
import { GiArtificialIntelligence } from 'react-icons/gi'
import { ProfileAboutStyled, SmallContainer } from '../styledComponents/globalStyled'
import { Skillcard, SkillCardBody, SkillCardHeader } from '../styledComponents/skillStyled'
import '../theme/core.css'
export default function TechnicalSkills() {


    return (
        <>
            <ProfileAboutStyled id="TechnicalSkills" >Technical Skills</ProfileAboutStyled>
            <ul>
                <SmallContainer>
                    <Skillcard>
                        <SkillCardHeader>
                            <SiNextdotjs className='skillimg' />
                        </SkillCardHeader>
                        <SkillCardBody>
                            <h4 className="techSkill">NextJS</h4>
                        </SkillCardBody>
                    </Skillcard>
                    <Skillcard>
                        <SkillCardHeader>
                            <SiReact className='skillimg' />
                        </SkillCardHeader>
                        <SkillCardBody>
                            <h4 className="techSkill">React</h4>
                        </SkillCardBody>
                    </Skillcard>
                    <Skillcard>
                        <SkillCardHeader>
                            <SiExpress className='skillimg' />
                        </SkillCardHeader>
                        <SkillCardBody>
                            <h4 className="techSkill">Express</h4>
                        </SkillCardBody>
                    </Skillcard>
                    <Skillcard>
                        <SkillCardHeader>
                            <SiReact className='skillimg' />
                        </SkillCardHeader>
                        <SkillCardBody>
                            <h4 className="techSkill">React Native</h4>
                        </SkillCardBody>
                    </Skillcard>
                    <Skillcard>
                        <SkillCardHeader>
                            <SiAwslambda className='skillimg' />
                        </SkillCardHeader>
                        <SkillCardBody>
                            <h4 className="techSkill">Lamdba</h4>
                        </SkillCardBody>
                    </Skillcard>
                    <Skillcard>
                        <SkillCardHeader>
                            <SiAmazonaws className='skillimg' />
                        </SkillCardHeader>
                        <SkillCardBody>
                            <h4 className="techSkill">AWS</h4>
                        </SkillCardBody>
                    </Skillcard>
                    <Skillcard>
                        <SkillCardHeader>
                            <FaNodeJs className='skillimg' />
                        </SkillCardHeader>
                        <SkillCardBody>
                            <h4 className="techSkill">NodeJS</h4>
                        </SkillCardBody>
                    </Skillcard>
                    <Skillcard>
                        <SkillCardHeader>
                            <SiJavascript className='skillimg' />
                        </SkillCardHeader>
                        <SkillCardBody>
                            <h4 className="techSkill">JavaScript</h4>
                        </SkillCardBody>
                    </Skillcard>
                    <Skillcard>
                        <SkillCardHeader>
                            <SiTypescript className='skillimg' />
                        </SkillCardHeader>
                        <SkillCardBody>
                            <h4 className="techSkill">TypeScript</h4>
                        </SkillCardBody>
                    </Skillcard>
                    <Skillcard>
                        <SkillCardHeader>
                            <SiMysql className='skillimg' />
                        </SkillCardHeader>
                        <SkillCardBody>
                            <h4 className="techSkill">MySQL</h4>
                        </SkillCardBody>
                    </Skillcard>
                    <Skillcard>
                        <SkillCardHeader>
                            <GiArtificialIntelligence className='skillimg' />
                        </SkillCardHeader>
                        <SkillCardBody>
                            <h4 className="techSkill">Machine Learning</h4>
                        </SkillCardBody>
                    </Skillcard>
                    <Skillcard>
                        <SkillCardHeader>
                            <SiJavascript className='skillimg' />
                        </SkillCardHeader>
                        <SkillCardBody>
                            <h4 className="techSkill">JAVA</h4>
                        </SkillCardBody>
                    </Skillcard>
                    <Skillcard>
                        <SkillCardHeader>
                            <SiMongodb className='skillimg' />
                        </SkillCardHeader>
                        <SkillCardBody>
                            <h4 className="techSkill">MongoDB</h4>
                        </SkillCardBody>
                    </Skillcard>
                    <Skillcard>
                        <SkillCardHeader>
                            <SiGithub className='skillimg' />
                        </SkillCardHeader>
                        <SkillCardBody>
                            <h4 className="techSkill">GitHub</h4>
                        </SkillCardBody>
                    </Skillcard>


                    {/* <Skillcard>
                        <SkillCardHeader>
                            <SiCplusplus className='skillimg' />
                        </SkillCardHeader>
                        <SkillCardBody>
                            <h4 className="techSkill">C++</h4>
                        </SkillCardBody>
                    </Skillcard>
                    <Skillcard>
                        <SkillCardHeader>
                            <TbCSharp className='skillimg' />
                        </SkillCardHeader>
                        <SkillCardBody>
                            <h4 className="techSkill">C#</h4>
                        </SkillCardBody>
                    </Skillcard> */}
                    <Skillcard>
                        <SkillCardHeader>
                            <SiBlender className='skillimg' />
                        </SkillCardHeader>
                        <SkillCardBody>
                            <h4 className="techSkill">Blender</h4>
                        </SkillCardBody>
                    </Skillcard>
                    <Skillcard>
                        <SkillCardHeader>
                            <SiAutodesk className='skillimg' />
                        </SkillCardHeader>
                        <SkillCardBody>
                            <h4 className="techSkill">3Ds Max</h4>
                        </SkillCardBody>
                    </Skillcard>
                    <Skillcard>
                        <SkillCardHeader>
                            <SiAutodesk className='skillimg' />
                        </SkillCardHeader>
                        <SkillCardBody>
                            <h4 className="techSkill">MudBox</h4>
                        </SkillCardBody>
                    </Skillcard>
                    <Skillcard>
                        <SkillCardHeader>
                            <SiAdobephotoshop className='skillimg' />
                        </SkillCardHeader>
                        <SkillCardBody>
                            <h4 className="techSkill">PhotoShop</h4>
                        </SkillCardBody>
                    </Skillcard>
                    <Skillcard>
                        <SkillCardHeader>
                            <SiAdobeaftereffects className='skillimg' />
                        </SkillCardHeader>
                        <SkillCardBody>
                            <h4 className="techSkill">After Effect</h4>
                        </SkillCardBody>
                    </Skillcard>



                    <Skillcard>
                        <SkillCardHeader>
                            <SiUnity className='skillimg' />
                        </SkillCardHeader>
                        <SkillCardBody>
                            <h4 className="techSkill">Unity</h4>
                        </SkillCardBody>
                    </Skillcard>
                </SmallContainer >

            </ul >


        </>
    );
}
